import './index.css'
import Button from '../button'

function PricingModulePayment({price,interval,CTA,checkOutUrl}){
    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent default form submission
        document.getElementById('checkout-form').submit();
    }
    return <div className='pricing-module'>
    <div className='small-text highlight-green'>{interval}</div>
    <h2 className='big-text'>{price}</h2>
    <form id='checkout-form' action={checkOutUrl} method='POST'>
    <button type='button' className='button small-text' onClick={handleSubmit}>
        {CTA}
      </button>    
    </form>
    <div className='benefits-grid'>
        <div className='globule'></div>
        <div className='benefit small-text'>Up to 10 sites</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited blog and social post ideas</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Content scheduler</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Download to word format</div>

        <div className='globule'></div>
        <div className='benefit small-text'>Unlimited feed items</div>
    </div>
    </div>
}

export default PricingModulePayment